<template>
  <div class="card shadow-sm">
    <div class="card-header bg-success text-white">
      <i class="fas fa-chart-pie me-2"></i> Répartition des utilisateurs par ville
    </div>
    <div class="card-body">
      <canvas ref="chartCanvas"></canvas>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import Chart from 'chart.js/auto';
import axios from 'axios';

interface VilleStats {
  ville: string;
  count: number;
}

export default defineComponent({
  name: 'UserCityDistributionChart',
  setup() {
    const chartCanvas = ref<HTMLCanvasElement | null>(null);
    let chart: Chart | null = null;

    const loadChart = async () => {
      try {
        const response = await axios.get<VilleStats[]>('/api/stats/repartition-par-ville');
        const data = response.data;

        const labels = data.map((item) => item.ville);
        const counts = data.map((item) => item.count);

        const backgroundColors = labels.map((_: string, i: number) =>
          `hsl(${(i * 360 / labels.length)}, 70%, 60%)`
        );

        if (chart) chart.destroy();

        chart = new Chart(chartCanvas.value as HTMLCanvasElement, {
          type: 'pie',
          data: {
            labels,
            datasets: [{
              label: 'Utilisateurs',
              data: counts,
              backgroundColor: backgroundColors,
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom'
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const label = context.label || '';
                    const value = context.parsed || 0;
                    return `${label}: ${value} utilisateur(s)`;
                  }
                }
              }
            }
          }
        });
      } catch (error) {
        console.error('Erreur de chargement des données :', error);
      }
    };

    onMounted(loadChart);

    return { chartCanvas };
  }
});
</script>

<style scoped>
canvas {
  max-width: 100%;
}
</style>
